import React from 'react';
import { Row, Col, Popconfirm, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { ActionButton } from '../../CustomComponents/Table/styledComponents';
import { PopoverGlobalStyle } from '../JobList/styledComponents';

export const multiSelectFilter = (row, columnId, filterValue) => {
  if (!filterValue || filterValue.length === 0) return true;
  const val = row.getValue(columnId);
  const strVal = val != null ? String(val) : 'N/A';
  return filterValue.includes(strVal);
};

export const createActionsColumn = (setSelectedItem, setDrawerVisible, handleDelete) => ({
  id: 'actions',
  header: 'Actions',
  size: 100,
  enableSorting: false,
  enableColumnFilter: false,
  cell: ({ row }) => (
    <Row gutter={8}>
      <Col>
        <Tooltip title='Edit'>
          <ActionButton
            icon={<EditOutlined />}
            onClick={() => {
              setSelectedItem(row.original);
              setDrawerVisible(true);
            }}
          />
        </Tooltip>
      </Col>
      {/* <Col>
        <Popconfirm
          title='Delete this record?'
          onConfirm={() => handleDelete(row.original.id)}
          okText='Yes'
          cancelText='No'
          overlayClassName='popover-delete-confirm'
        >
          <PopoverGlobalStyle />
          <Tooltip title='Delete'>
            <ActionButton icon={<DeleteOutlined />} />
          </Tooltip>
        </Popconfirm>
      </Col> */}
    </Row>
  )
});

export const urlCell = ({ getValue }) => {
  const val = getValue();
  return val ? (
    <a href={val} target='_blank' rel='noopener noreferrer' title={val}>
      {val.length > 40 ? val.slice(0, 40) + '...' : val}
    </a>
  ) : (
    <span>—</span>
  );
};

export const longTextCell = ({ getValue }) => {
  const val = getValue();
  return val ? (
    <span title={val}>{val.length > 60 ? val.slice(0, 60) + '...' : val}</span>
  ) : (
    <span>—</span>
  );
};
